import parse from 'html-react-parser';
import lexicalToHtml from './lexicalToHtml';

/**
 * Helper para parsear HTML o contenido Lexical desde Payload CMS
 *
 * Uso:
 * import parseHtml from '../utils/parseHtml';
 * <p>{parseHtml(contenido)}</p>
 *
 * @param {string|Object} content - String HTML o objeto Lexical JSON
 * @returns {JSX.Element|string} - Elementos React o string si no hay HTML
 */
const parseHtml = (content) => {
  if (!content) {
    return '';
  }

  // Si es un objeto (Lexical JSON), convertirlo primero a HTML
  if (typeof content === 'object') {
    const html = lexicalToHtml(content);
    return html ? parse(html) : '';
  }

  // Si es un string pero no contiene etiquetas HTML, retornar tal cual
  if (typeof content === 'string' && !content.includes('<')) {
    return content;
  }

  // Parsear el HTML a componentes React
  if (typeof content === 'string') {
    return parse(content);
  }

  return '';
};

export default parseHtml;
